module.exports = "//static.hsappstatic.net/LoginUI/static-1.15179/img/connect.com-full-logo-color.svg"